module.exports = __webpack_public_path__ + "img/icons B_31.50ae06a2.svg";